// Área de Gestão: entrada (login Microsoft no servidor), cabeçalho, menu lateral, busca global e
// helpers de cartão. Port de index.html:2016 (showAdminLogin, substituída), 2257 (showAdmin),
// 2287 (renderAdmin), 2361 (busca), 2410 (makeCard…), 2426 (menu lateral), 2825 (mdObraRow).

import { pode, primeiraAreaDaGestao } from '../motor/index.js';
import type { ObraDTO, SelosDTO, VistoriaDTO } from '../compartilhado/api.js';
import { api, carregarEu, eu, ErroApi } from './api.js';
import { buildDash } from './gestao-dash.js';
import { buildHist } from './gestao-hist.js';
import { buildReports } from './gestao-relatorios.js';
import { buildChecklist, buildConfig, buildObras, buildUsuarios } from './gestao-cadastros.js';
import { buildGestao } from './gestao-custos.js';
import { S, hoje } from './vistoriador.js';
import { compTxt, esc, lsGet, lsSet, toast } from './util.js';

/** Estado da gestão em memória (cópias de leitura; a fonte é a API). */
export const G: any = {
  cadastro: [] as ObraDTO[],
  vistorias: [] as VistoriaDTO[],
  selos: { alojamentosPendentes: 0, vistoriasAguardando: 0 } as SelosDTO,
  compView: null as string | null,
  histF: { st: '', nome: '', comp: '' },
  obrasAbertas: {} as Record<string, boolean>,
  obrasOpen: {} as Record<string, boolean>,
  obraSel: null as string | null,
};

let _admTimer: any = null;
export function pararAtualizacaoGestao() { if (_admTimer) { clearInterval(_admTimer); _admTimer = null; } }

export function can(p: any): boolean { return pode(eu, p); }
export function semAprovar(): boolean { if (can('aprovar')) return false; toast('🔒 Seu acesso não permite aprovar, reprovar ou excluir vistorias', 'error'); return true; }
export function compAtual(): string { return G.compView || compTxt(hoje()); }

export async function carregarCadastro() { G.cadastro = await api<ObraDTO[]>('GET', '/api/cadastro'); return G.cadastro; }
export async function carregarVistorias() { G.vistorias = await api<VistoriaDTO[]>('GET', '/api/vistorias'); return G.vistorias; }
export async function carregarSelos() {
  try { G.selos = await api<SelosDTO>('GET', '/api/selos?comp=' + compAtual()); } catch (e: any) { if (e instanceof ErroApi && e.status === 401) throw e; }
  return G.selos;
}

/** "Área de gestão": entra direto com a sessão Microsoft (sem tela de senha). */
export async function showAdminLogin() {
  try { await carregarEu(); } catch (e: any) {
    if (!(e instanceof ErroApi && e.status === 401)) toast('⚠️ Sem conexão com o servidor. Tente novamente.', 'error');
    return;
  }
  showAdmin();
}

export function showAdmin() {
  renderAdmin('dash');
  pararAtualizacaoGestao();
  // atualização automática enquanto o painel estiver aberto (protótipo: a cada 2 min)
  _admTimer = setInterval(function () {
    if (!document.getElementById('adm-hdr')) { pararAtualizacaoGestao(); return; }
    if (document.querySelector('[id^="reject-form-"]')) return; // não atrapalha quem está digitando
    const antes = JSON.stringify(G.selos);
    carregarSelos().then(function (s) {
      if (JSON.stringify(s) !== antes) renderAdmin(S.tab || 'dash');
    }).catch(function () { /* tenta de novo no próximo ciclo */ });
  }, 120000);
}

export function admLogout() {
  pararAtualizacaoGestao();
  location.href = '/auth/sair';
}

export function syncNow(btn?: any) {
  if (btn) { btn.disabled = true; }
  Promise.all([carregarSelos(), carregarCadastro()]).then(function () {
    toast('🔄 Painel atualizado', 'success');
    renderAdmin(S.tab || 'dash');
  }).catch(function (e: any) {
    toast('⚠️ Nao foi possivel atualizar: ' + e.message, 'error');
    if (btn) { btn.disabled = false; }
  });
}

// ADMIN PANEL
export function renderAdmin(tab: string) {
  if (!eu) { showAdminLogin(); return; }
  const _okTab = function (t: string) { return t === 'usuarios' ? eu!.perfil === 'admin' : can(t); };
  if (!_okTab(tab)) {
    const _alt = primeiraAreaDaGestao(eu);
    if (!_alt) {
      (document.getElementById('app') as HTMLElement).innerHTML = '<div style="min-height:100vh;background:#060e1a;display:flex;align-items:center;justify-content:center;padding:20px"><div style="max-width:340px;background:rgba(8,18,38,.85);border-radius:24px;border:1px solid rgba(201,168,76,.2);padding:32px 24px;text-align:center;color:#fff"><div style="font-size:40px;margin-bottom:10px">🔒</div><div style="font-weight:800;font-size:18px;margin-bottom:8px">Nenhuma área liberada</div><div style="font-size:13px;color:rgba(200,220,248,.7);line-height:1.5;margin-bottom:20px">Peça ao administrador para liberar seu acesso.</div><button onclick="admLogout()" class="btn btn-primary">Sair</button></div></div>';
      return;
    }
    tab = _alt;
  }
  S.tab = tab;
  document.body.style.background = '#f4f7fb'; document.body.style.overflow = 'hidden';

  const app = document.getElementById('app') as HTMLElement;
  app.innerHTML =
    '<div id="adm-shell" style="background:#E9EFF7;height:100%;min-height:100%;display:flex;flex-direction:column;overflow:hidden">'
    + '<div id="adm-hdr" style="background:linear-gradient(135deg,#0d1f42,#1a3a70);padding:14px 18px;padding-top:max(14px,env(safe-area-inset-top));display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap;flex-shrink:0;box-shadow:0 4px 20px rgba(0,0,0,.4)">'
    + '<div style="display:flex;align-items:center;gap:12px;min-width:0">'
    + '<img src="/icon-192.png" alt="" style="width:34px;height:34px;border-radius:9px;display:block;object-fit:cover;flex-shrink:0">'
    + '<div style="min-width:0"><div style="font-weight:800;font-size:clamp(15px,2vw,20px);color:#fff;white-space:nowrap">Área de Gestão</div><div style="font-size:clamp(9px,1.2vw,11px);color:rgba(150,185,225,.55);letter-spacing:.5px;text-transform:uppercase">LBX Vistoria</div></div>'
    + '</div>'
    + '<div style="display:flex;align-items:center;gap:8px;flex:none;color:rgba(220,232,250,.85);font-size:12px;font-weight:700"><span style="white-space:nowrap">👤 ' + esc((eu.nome || '').split(' ')[0]) + ' · ' + esc(eu.rotulo) + '</span></div>'
    + '<div style="position:relative;flex:1;max-width:320px;min-width:140px">'
    + '<input id="global-search" type="text" placeholder="🔍 Buscar obra ou alojamento..." oninput="globalSearchInput()" onfocus="globalSearchInput()" onblur="globalSearchBlur()" style="width:100%;padding:8px 12px;border-radius:10px;border:1.5px solid rgba(255,255,255,.15);background:rgba(255,255,255,.08);color:#fff;font-size:12px;font-family:inherit;outline:none;box-sizing:border-box">'
    + '<div id="global-search-results" style="display:none;position:absolute;top:calc(100% + 6px);left:0;right:0;background:#fff;border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,.25);max-height:320px;overflow-y:auto;z-index:50"></div>'
    + '</div>'
    + '</div>'
    + '<div id="adm-body" style="flex:1;display:flex;overflow:hidden;min-height:0">'
    + '<div id="adm-rail"></div>'
    + '<div id="adm-main" style="padding:clamp(8px,2vw,28px);max-width:none;margin:0;width:100%;box-sizing:border-box;flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;overflow-x:hidden">'
    + '<div id="adm-content"></div>'
    + '</div></div></div>';

  buildAdmRail(tab, G.selos.alojamentosPendentes, G.selos.vistoriasAguardando);
  carregarSelos().then(function (s) { if (S.tab === tab && document.getElementById('adm-rail')) buildAdmRail(tab, s.alojamentosPendentes, s.vistoriasAguardando); }).catch(function () { /* selos ficam os últimos */ });
  if (!G.cadastro.length) carregarCadastro().catch(function () { /* busca global fica vazia */ });

  const contentEl = document.getElementById('adm-content') as HTMLElement;
  const TT: any = ({ dash: ['Painel de vistorias', 'Acompanhe as vistorias de cada alojamento no mês'], hist: ['Vistorias analisadas', 'Aprove, reprove e consulte o que foi enviado'], reports: ['Relatórios e histórico', 'Desempenho das obras por competência e por ano'], obras: ['Obras e alojamentos', 'Cadastro, contratos, inventário e custos'], gestao: ['Obras e alojamentos', 'Cadastro, contratos, inventário e custos'], checklist: ['Checklist de itens', 'Itens conferidos em cada vistoria'], config: ['Ajustes gerais', 'Metas e regras do sistema'], usuarios: ['Usuários e acessos', 'Defina quem pode ver cada área'] } as any)[tab];
  if (TT) { const th = document.createElement('div'); th.id = 'adm-title'; th.innerHTML = '<h1>' + TT[0] + '</h1><p>' + TT[1] + '</p>'; (contentEl.parentNode as HTMLElement).insertBefore(th, contentEl); }

  const falha = function (e: any) {
    if (e instanceof ErroApi && e.status === 401) return;
    contentEl.innerHTML = '<div style="padding:24px;color:#b91c1c;font-weight:600">Não foi possível carregar: ' + esc(e.message) + '</div>';
  };
  let p: Promise<any>;
  if (tab === 'dash') p = buildDash(contentEl);
  else if (tab === 'hist') p = buildHist(contentEl);
  else if (tab === 'reports') p = buildReports(contentEl);
  else if (tab === 'checklist') p = buildChecklist(contentEl);
  else if (tab === 'usuarios') p = buildUsuarios(contentEl);
  else if (tab === 'obras' || tab === 'gestao') {
    const seg = document.createElement('div'); seg.style.cssText = 'display:inline-flex;flex-wrap:wrap;background:#e2e8f0;border-radius:12px;padding:4px;gap:4px;margin-bottom:14px';
    [['obras', '🏗️ Cadastro de obras e alojamentos'], ['gestao', '💰 Contratos, inventário e custos']].filter(function (o) { return can(o[0]); }).forEach(function (o) {
      const bt = document.createElement('button'); bt.type = 'button'; bt.textContent = o[1] as string;
      bt.style.cssText = 'border:none;border-radius:9px;padding:9px 16px;font-weight:700;font-size:13px;font-family:inherit;cursor:pointer;background:' + (tab === o[0] ? '#1F3864' : 'transparent') + ';color:' + (tab === o[0] ? '#fff' : '#475569');
      bt.onclick = function () { renderAdmin(o[0] as string); }; seg.appendChild(bt);
    });
    contentEl.appendChild(seg);
    const body = document.createElement('div'); body.className = tab === 'gestao' ? 'cols2' : 'masonry'; contentEl.appendChild(body);
    p = tab === 'obras' ? buildObras(body) : buildGestao(body);
  }
  else p = buildConfig(contentEl);
  Promise.resolve(p).catch(falha);
  if (tab !== 'reports') contentEl.className = '';
}

// ── Busca global (obras / alojamentos) ──────────────────────────────────────
export function globalSearchInput() {
  const inp = document.getElementById('global-search') as HTMLInputElement;
  const box = document.getElementById('global-search-results') as HTMLElement;
  if (!inp || !box) return;
  const q = inp.value.trim().toLowerCase();
  if (!q) { box.style.display = 'none'; box.innerHTML = ''; return; }
  const obras: ObraDTO[] = G.cadastro;
  let results: any[] = [];
  obras.forEach(function (ob) {
    if ((ob.nome || '').toLowerCase().indexOf(q) >= 0) {
      results.push({ type: 'obra', label: ob.nome, sub: 'Obra · ' + ((ob.alojamentos && ob.alojamentos.length) || 0) + ' alojamento(s)', obraId: ob.id });
    }
    (ob.alojamentos || []).forEach(function (al) {
      if ((al.nome || '').toLowerCase().indexOf(q) >= 0 || (al.responsavel || '').toLowerCase().indexOf(q) >= 0) {
        results.push({ type: 'aloj', label: al.nome, sub: ob.nome + (al.responsavel ? ' · ' + al.responsavel : ''), obraId: ob.id, alojName: al.nome });
      }
    });
  });
  results = results.slice(0, 8);
  box.innerHTML = '';
  if (!results.length) {
    box.innerHTML = '<div style="padding:12px 14px;font-size:12px;color:#94a3b8">Nenhum resultado</div>';
    box.style.display = 'block'; return;
  }
  results.forEach(function (r) {
    const row = document.createElement('div');
    row.style.cssText = 'padding:10px 14px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px';
    row.innerHTML = '<span style="font-size:14px;flex-shrink:0">' + (r.type === 'obra' ? '🏗️' : '📍') + '</span><div style="min-width:0;flex:1"><div style="font-weight:700;font-size:13px;color:#1e293b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(r.label) + '</div><div style="font-size:11px;color:#64748b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(r.sub) + '</div></div>';
    row.onmouseenter = function () { row.style.background = '#f8fafc'; };
    row.onmouseleave = function () { row.style.background = ''; };
    row.onmousedown = function (e) {
      e.preventDefault();
      box.style.display = 'none'; inp.value = '';
      if (r.type === 'obra') {
        G.obraSel = r.obraId;
        obras.forEach(function (o) { G.obrasOpen[o.id] = (o.id === r.obraId); });
        renderAdmin('obras');
      } else {
        G.histF.nome = r.alojName; G.histF.st = ''; G.histF.comp = '';
        renderAdmin('hist');
      }
    };
    box.appendChild(row);
  });
  box.style.display = 'block';
}
export function globalSearchBlur() {
  setTimeout(function () { const box = document.getElementById('global-search-results'); if (box) box.style.display = 'none'; }, 200);
}

export function makeCard(head: string, bodyFn: (b: HTMLElement, h: HTMLElement) => void): HTMLElement {
  const d = document.createElement('div'); d.className = 'card';
  const h = document.createElement('div'); h.className = 'card-head'; h.innerHTML = head; d.appendChild(h);
  const b = document.createElement('div'); b.className = 'card-body'; d.appendChild(b); bodyFn(b, h);
  return d;
}

// ── Barra lateral da Área de Gestão ─────────────────────────────────────────
const RAIL_ICONS: Record<string, string> = {
  menu: '<line x1="4" y1="7" x2="20" y2="7"></line><line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="17" x2="20" y2="17"></line>',
  gestao: '<circle cx="12" cy="12" r="9"></circle><path d="M14.8 9.2c-.5-.8-1.5-1.2-2.8-1.2-1.6 0-2.8.8-2.8 2 0 3 5.6 1.4 5.6 4.2 0 1.2-1.2 2-2.8 2-1.4 0-2.4-.5-3-1.4"></path><line x1="12" y1="6" x2="12" y2="8"></line><line x1="12" y1="16" x2="12" y2="18"></line>',
  dash: '<rect x="3" y="3" width="7" height="7" rx="1.6"></rect><rect x="14" y="3" width="7" height="7" rx="1.6"></rect><rect x="3" y="14" width="7" height="7" rx="1.6"></rect><rect x="14" y="14" width="7" height="7" rx="1.6"></rect>',
  hist: '<rect x="5" y="4" width="14" height="17" rx="2"></rect><path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"></path><path d="M9 12.2l2 2 4-4.2"></path>',
  reports: '<rect x="4" y="11" width="4" height="9" rx="1"></rect><rect x="10" y="6" width="4" height="14" rx="1"></rect><rect x="16" y="14" width="4" height="6" rx="1"></rect>',
  obras: '<rect x="4" y="3" width="10" height="18" rx="1"></rect><rect x="14" y="9" width="6" height="12" rx="1"></rect><line x1="7" y1="7" x2="7" y2="7.01"></line><line x1="11" y1="7" x2="11" y2="7.01"></line><line x1="7" y1="11" x2="7" y2="11.01"></line><line x1="11" y1="11" x2="11" y2="11.01"></line><line x1="7" y1="15" x2="7" y2="15.01"></line><line x1="11" y1="15" x2="11" y2="15.01"></line>',
  checklist: '<path d="M4 6l1.5 1.5L8 5"></path><line x1="11" y1="6" x2="20" y2="6"></line><path d="M4 12l1.5 1.5L8 11"></path><line x1="11" y1="12" x2="20" y2="12"></line><path d="M4 18l1.5 1.5L8 17"></path><line x1="11" y1="18" x2="20" y2="18"></line>',
  config: '<line x1="4" y1="6" x2="20" y2="6"></line><circle cx="9" cy="6" r="2.3" fill="currentColor" stroke="none"></circle><line x1="4" y1="12" x2="20" y2="12"></line><circle cx="16" cy="12" r="2.3" fill="currentColor" stroke="none"></circle><line x1="4" y1="18" x2="20" y2="18"></line><circle cx="11" cy="18" r="2.3" fill="currentColor" stroke="none"></circle>',
  sync: '<path d="M20 11A8 8 0 1 0 19 16"></path><polyline points="20 5 20 11 14 11"></polyline>',
  usuarios: '<circle cx="9" cy="8" r="3.2"></circle><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"></path><circle cx="17" cy="9" r="2.4"></circle><path d="M17 14.5c2.4 0 4 1.8 4 4.5"></path>',
  exit: '<path d="M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3"></path><polyline points="15 16 20 11 15 6"></polyline><line x1="20" y1="11" x2="8" y2="11"></line>',
};
function railBtn(opts: any): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = 'rail-btn'; b.type = 'button'; b.title = opts.tip; b.setAttribute('aria-label', opts.tip);
  const sz = opts.size || 52;
  const bg = opts.on ? 'linear-gradient(145deg,#3A5278,#24354F)' : 'transparent';
  const shadow = opts.on ? '0 10px 20px rgba(36,53,79,.35),inset 0 1px 0 rgba(255,255,255,.25)' : 'none';
  if (opts.on) b.classList.add('on');
  b.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;border-radius:14px;display:flex;align-items:center;justify-content:center;background:' + bg + ';box-shadow:' + shadow + ';flex-shrink:0';
  b.innerHTML = '<div class="rail-ic-box" style="width:' + sz + 'px;height:' + sz + 'px;display:flex;align-items:center;justify-content:center">'
    + '<svg width="' + (opts.iconSize || 22) + '" height="' + (opts.iconSize || 22) + '" viewBox="0 0 24 24" fill="none" style="color:' + (opts.color || (opts.on ? '#fff' : '#4A5C75')) + '" stroke="' + (opts.color || (opts.on ? '#fff' : '#4A5C75')) + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + RAIL_ICONS[opts.icon] + '</svg></div>'
    + '<span class="rail-lbl" style="color:' + (opts.on ? '#fff' : '#24354F') + '">' + esc(opts.lbl || opts.tip) + '</span>'
    + (opts.badge ? '<span class="rail-badge" style="position:absolute;top:3px;right:3px;min-width:17px;height:17px;padding:0 4px;border-radius:99px;background:' + (opts.badgeColor || '#dc2626') + ';color:#fff;font-size:10px;font-weight:800;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-sizing:content-box">' + opts.badge + '</span>' : '')
    + '<span class="tip">' + esc(opts.tip) + '</span>';
  b.onclick = opts.onClick;
  return b;
}
function buildAdmRail(tabAtual: string, pendAloj: number, pendSubs: number) {
  const rail = document.getElementById('adm-rail');
  if (!rail) return;
  rail.innerHTML = '';
  const aberto = !!lsGet('railopen');
  rail.className = aberto ? 'open' : '';
  const bMenu = railBtn({ icon: 'menu', tip: aberto ? 'Recolher menu' : 'Expandir menu', lbl: 'Recolher menu', size: 44, iconSize: 20, color: '#24354F', onClick: function () {
    const ab = !rail.classList.contains('open');
    rail.classList.toggle('open', ab); lsSet('railopen', ab);
    bMenu.title = ab ? 'Recolher menu' : 'Expandir menu';
  } });
  bMenu.classList.add('rail-menu'); bMenu.style.position = 'relative'; bMenu.style.marginBottom = '4px'; rail.appendChild(bMenu);
  const topo: any[] = [
    { t: 'dash', icon: 'dash', tip: 'Painel de vistorias', lbl: 'Painel de vistorias', badge: pendAloj > 0 ? pendAloj : null, badgeColor: '#dc2626' },
    { t: 'hist', icon: 'hist', tip: 'Vistorias analisadas', lbl: 'Vistorias analisadas', badge: pendSubs > 0 ? pendSubs : null, badgeColor: '#d97706' },
    { t: 'reports', icon: 'reports', tip: 'Relatórios e histórico', lbl: 'Relatórios e histórico' },
    { sep: 1 },
    { t: can('obras') ? 'obras' : 'gestao', perm: 'obrasgest', icon: 'obras', tip: 'Obras e alojamentos (cadastro, contratos e custos)', lbl: 'Obras e alojamentos' },
    { t: 'checklist', icon: 'checklist', tip: 'Checklist de itens', lbl: 'Checklist de itens' },
    { sep: 1 },
    { t: 'config', icon: 'config', tip: 'Ajustes gerais', lbl: 'Ajustes gerais' },
    { t: 'usuarios', icon: 'usuarios', tip: 'Usuários e acessos (administrador)', lbl: 'Usuários e acessos' },
  ].filter(function (it) {
    if (it.sep) return true;
    if (it.t === 'usuarios') return eu && eu.perfil === 'admin';
    if (it.perm === 'obrasgest') return can('obras') || can('gestao');
    return can(it.t);
  });
  topo.forEach(function (it) {
    if (it.sep) {
      const s = document.createElement('div');
      s.className = 'rail-sep'; s.style.cssText = 'width:32px;height:1px;background:rgba(36,53,79,.16);margin:6px 0;flex-shrink:0';
      rail.appendChild(s); return;
    }
    const on = (it.t === tabAtual) || (it.perm === 'obrasgest' && (tabAtual === 'obras' || tabAtual === 'gestao'));
    const b = railBtn({ on: on, icon: it.icon, tip: it.tip, lbl: it.lbl, badge: it.badge, badgeColor: it.badgeColor, onClick: function () { if (window.innerWidth <= 480) lsSet('railopen', false); renderAdmin(it.t); } });
    b.style.position = 'relative';
    rail.appendChild(b);
  });
  const spacer = document.createElement('div'); spacer.style.cssText = 'flex:1 1 auto;min-height:6px'; rail.appendChild(spacer);
  const bSync = railBtn({ icon: 'sync', tip: 'Atualizar agora', size: 44, iconSize: 18, color: '#4A5C75', onClick: function (this: any) { syncNow(this); } });
  bSync.style.position = 'relative'; rail.appendChild(bSync);
  const bExit = railBtn({ icon: 'exit', tip: 'Sair da gestão', size: 44, iconSize: 18, color: '#B3261E', onClick: function () { admLogout(); } });
  bExit.style.position = 'relative'; bExit.style.marginBottom = '2px'; rail.appendChild(bExit);
}

// linha de obra (lista da direita): clica para ver os alojamentos dela
export function mdObraRow(ob: { id: string; nome: string }, sel: boolean, badge: string, onClick: () => void, delFn?: () => void): HTMLElement {
  const row = document.createElement('div');
  row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:14px 18px;border-radius:12px;margin-bottom:10px;cursor:pointer;user-select:none;background:linear-gradient(135deg,#1F3864,#2E5C8A);'
    + (sel ? 'box-shadow:0 0 0 3px #5BC6F4,0 14px 28px rgba(36,53,79,.35),inset 0 1px 0 rgba(255,255,255,.18);transform:translateX(-4px)' : 'box-shadow:0 6px 14px rgba(36,53,79,.2),inset 0 1px 0 rgba(255,255,255,.12);opacity:.95');
  const ar = document.createElement('span'); ar.style.cssText = 'color:' + (sel ? '#5BC6F4' : '#fff') + ';font-size:12px;flex-shrink:0'; ar.textContent = sel ? '▶' : '▷';
  const t = document.createElement('div'); t.style.cssText = 'font-weight:800;color:#fff;font-size:14px;flex:1;min-width:0'; t.textContent = '🏗️ ' + ob.nome;
  t.style.fontSize = '15px'; t.style.lineHeight = '1.3'; t.style.overflowWrap = 'anywhere';
  const bd = document.createElement('div'); bd.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;justify-content:flex-end;flex:none;max-width:60%';
  String(badge).split(' · ').forEach(function (pt) {
    const ch = document.createElement('span');
    const destaque = /R\$|%/.test(pt);
    ch.style.cssText = 'border-radius:99px;white-space:nowrap;font-weight:800;' + (destaque
      ? 'background:#fff;color:#1F3864;font-size:14px;padding:5px 14px'
      : 'background:rgba(255,255,255,.18);color:#e6eefb;font-size:13px;padding:5px 12px');
    ch.textContent = pt; bd.appendChild(ch);
  });
  row.appendChild(ar); row.appendChild(t); row.appendChild(bd);
  if (delFn) {
    const d = document.createElement('button'); d.type = 'button'; d.textContent = 'Excluir';
    d.style.cssText = 'background:rgba(220,38,38,.25);border:1px solid rgba(220,38,38,.4);color:#fff;border-radius:6px;padding:4px 10px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit';
    d.onclick = function (e) { e.stopPropagation(); delFn(); }; row.appendChild(d);
  }
  row.onclick = onClick;
  return row;
}

export function collapsibleObraCard(title: string, obraId: string, openMap: Record<string, boolean>, bodyFn: (b: HTMLElement) => void): HTMLElement {
  if (!(obraId in openMap)) openMap[obraId] = true;
  const isOpen = openMap[obraId];
  return makeCard('', function (b, h) {
    h.innerHTML = ''; h.style.cssText = 'background:linear-gradient(135deg,#1F3864,#2E5C8A);padding:12px 18px;display:flex;align-items:center;gap:10px;cursor:pointer;user-select:none';
    const arrow = document.createElement('span'); arrow.style.cssText = 'color:#fff;font-size:12px;display:inline-block;flex-shrink:0;transition:transform .2s;transform:rotate(' + (isOpen ? 90 : 0) + 'deg)'; arrow.textContent = '▶';
    const t = document.createElement('div'); t.style.cssText = 'font-weight:800;color:#fff;font-size:14px;flex:1'; t.textContent = title;
    h.appendChild(arrow); h.appendChild(t);
    b.style.display = isOpen ? '' : 'none';
    h.onclick = function () {
      openMap[obraId] = !openMap[obraId];
      b.style.display = openMap[obraId] ? '' : 'none';
      arrow.style.transform = 'rotate(' + (openMap[obraId] ? 90 : 0) + 'deg)';
    };
    bodyFn(b);
  });
}

/** Caixa de carregamento enquanto a API responde. */
export function carregando(el: HTMLElement, txt?: string) {
  el.innerHTML = '<div style="text-align:center;padding:40px;color:#94a3b8;font-size:14px">' + (txt || 'Carregando…') + '</div>';
}
